import { isDefined } from "@clipboard-health/util-ts";
import {
  BackgroundCheckMissingData,
  type BackgroundCheckMissingDataType,
} from "@src/appV2/OpenShifts/ShiftAction/types";
import { generatePath } from "react-router-dom";

import {
  REQUIRED_DATA_QUERY_PARAM_KEY,
  RETURN_TO_QUERY_PARAM_KEY,
  type ReturnToType,
  SHIFT_ID_QUERY_PARAM_KEY,
} from "../BackgroundChecks/constants";
import { BACKGROUND_CHECK_INTRO_FULL_PATH } from "../Documents/paths";

export function createBackgroundCheckUrlFromMissingDataTypes(params: {
  queryParams: URLSearchParams;
  returnTo?: ReturnToType;
  shiftId?: string;
  missingBackgroundCheckDataTypes?: BackgroundCheckMissingDataType[];
}) {
  const { queryParams, returnTo, shiftId, missingBackgroundCheckDataTypes = [] } = params;
  const path = generatePath(BACKGROUND_CHECK_INTRO_FULL_PATH);
  if (isDefined(shiftId)) {
    queryParams.set(SHIFT_ID_QUERY_PARAM_KEY, shiftId);
  }

  if (isDefined(returnTo)) {
    queryParams.set(RETURN_TO_QUERY_PARAM_KEY, returnTo);
  }

  queryParams.delete(REQUIRED_DATA_QUERY_PARAM_KEY);
  (missingBackgroundCheckDataTypes.length === 0
    ? Object.values(BackgroundCheckMissingData)
    : missingBackgroundCheckDataTypes
  ).forEach((missingDataType) => {
    queryParams.append(REQUIRED_DATA_QUERY_PARAM_KEY, missingDataType);
  });

  return `${path}?${queryParams.toString()}`;
}
